import React from "react";

type AuthSubmitButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  loading?: boolean;
  children: React.ReactNode;
};

/** Primary auth submit with inline spinner (no full-screen FrontLoader). */
export function AuthSubmitButton({ loading, children, className = "", disabled, ...rest }: AuthSubmitButtonProps) {
  return (
    <button
      type="submit"
      className={`com-btn com-btn--auth-submit${loading ? " is-loading" : ""} ${className}`.trim()}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? (
        <span className="com-btn__auth-spinner spinner-border spinner-border-sm" role="status" aria-hidden />
      ) : null}
      <span className="com-btn__auth-label">{children}</span>
    </button>
  );
}

export default AuthSubmitButton;
